import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar as AppBarComponent,
  Toolbar,
  IconButton,
  Link,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import {
  BrandLogoFull as BrandLogoFullIcon,
  BrandLogo as BrandLogoIcon,
} from '../../components/Brand';
import FlagIcon from '../../components/FlagIcon';
import SupportButton from '../../components/SupportButton';
import { useHistory } from 'react-router-dom';
import { isShowIndianFlag } from '../../special-params';
import InstructionsHighlight from '../../components/InstructionsHighlight';
import settings from '../../components/settings';
import DiwaliDiya from '../../components/DiwaliDiya';
import SubscriptionAccountMenu from './SubscriptionAccountMenu/SubscriptionAccountMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .instructions-text': {
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block',
        marginRight: 7,
      },
    },

    '& .MuiToolbar-gutters': {
      paddingLeft: 10,
      paddingRight: 10,
      [theme.breakpoints.up('md')]: {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${settings.drawerWidth}px)`,
      marginLeft: settings.drawerWidth,
    },
    zIndex: 2000,
  },
  brandFull: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      marginLeft: 5,
      display: 'inline-flex',
      padding: '8px 0',
    },
  },
  brand: {
    display: 'inline-flex',
    marginRight: theme.spacing(2),
    padding: '8px 0',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  menuButton: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  search: {
    flex: 1,
    '& > div': {
      borderRadius: 5,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 90,
      maxWidth: 555,
    },
  },
  rightMenu: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  statusListeners: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline-flex',
      marginRight: theme.spacing(1),
      alignItems: 'center',
    },
  },
  leftMenu: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  },
  HomeLink: {},
}));

const HomeLink = ({ children = '', className = '' }) => {
  const classes = useStyles();
  const history = useHistory();

  const onClick = (e) => {
    e.preventDefault();
    history.push('/algos');
  };

  return (
    <Link
      className={`${classes.HomeLink} ${className}`}
      href="#"
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

const SubscriptionAppBar = ({ handleDrawerToggle, authLogout, user }) => {
  const classes = useStyles();

  return (
    <AppBarComponent
      position="fixed"
      color="inherit"
      className={classes.root}
      id="app-bar-main"
    >
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
          color="primary"
        >
          <MenuIcon />
        </IconButton>
        <HomeLink className={classes.brandFull}>
          <BrandLogoFullIcon />
        </HomeLink>
        <HomeLink className={classes.brand}>
          <BrandLogoIcon />
        </HomeLink>

        <DiwaliDiya />

        {isShowIndianFlag && <FlagIcon />}

        <div className={classes.rightMenu}>
          <SupportButton topBar />
          <InstructionsHighlight topBar />
          <SubscriptionAccountMenu authLogout={authLogout} user={user} />
        </div>
      </Toolbar>
    </AppBarComponent>
  );
};

export default SubscriptionAppBar;
